export enum OfferStatus {
    active = 'active',
    stop = 'stop',
    block = 'block',
    finished = 'finished',
    canceled = 'canceled',
}

export enum OfferState {
    prematch = 'prematch',
    live = 'live',
}

export const OfferEventCountType = {
    prematch: '1',
    live: '2',
} as const;
export type OfferEventCountType = typeof OfferEventCountType[keyof typeof OfferEventCountType];

export enum CurrentOfferStatus {
    active = 'active',
    finished = 'finished',
}
